export const payments = {
  qrcode: {
    title: "Código QR",
    subtitle: "Escaneá el código QR para pagar",
  },
  addFunds: {
    title: "Agregar Créditos",
    subtitle:
      "Tus créditos se agregarán automáticamente al confirmarse el pago",
    amount: "Cantidad",
    submit: "Agregar Créditos",
    processing: "Procesando...",
    error: "Error al agregar créditos",
    success: "Créditos agregados correctamente",
    gateway: "Forma de Pago",
    bonus: "Bono de depósito (3% - 10%)",
    total: "Total (Precisión de 3 decimales 10,000 = R$ 10,00)",
    note: "Estás realizando una compra segura.",
  },
  switchPlan: {
    title: "Cambiar Plan",
    subtitle: "Elegí tu nuevo plan de suscripción",
    submit: "Cambiar Plan",
    processing: "Procesando...",
    error: "Error al cambiar de plan",
    success: "Plan cambiado correctamente",
  },
  history: {
    client: "Cliente",
    title: "Historial de Pagos",
    empty: "No se encontró historial de pagos",
    date: "Fecha",
    description: "Descripción",
    type: "Tipo",
    amount: "Cantidad",
    status: "Estado",
    actions: "Acciones",
  },
  types: {
    prepaid: "Prepago",
    subscription: "Suscripción",
    deposit_bonus: "Bono de depósito",
  },
  status: {
    pending: "Pendiente",
    paid: "Pagado",
    failed: "Fallido", // Or "Error"
    cancelled: "Cancelado",
  },
  pending: {
    pay: "Pago Pendiente",
    payNow: "Pagar Ahora",
  },
  error: {
    loading: "Error al cargar el historial de pagos",
  },
};
